import { formatPathName } from '@/modules/warehouse/services/storage-location-service';
import { formatBool } from '@/utils/shared';
import TRUNCATE_UNITS from '@/utils/enum/TRUNCATE_UNITS';
import STORAGE_TYPES from '@/modules/warehouse/enums/STORAGE_TYPES';

const WAREHOUSE_WIDGETS = Object.freeze({
  STORAGE_ELEMENT_WIDGETS: [
    {
      id: 'storageelements',
      path: 'storageelements',
      getData: response => response.data.data?.map(item => item.data),
      headers: [
        {
          text: 'Common.type',
          value: 'storageType',
          icon: value => ({ icon: STORAGE_TYPES[value].icon })
        },
        {
          text: 'Common.label',
          value: 'label',
          truncateUnit: TRUNCATE_UNITS.STRING,
          truncateAfter: 20
        },
        {
          text: 'Dashboard.widgets.storageelements.headers.labelPathElements',
          value: 'joinedLabel',
          truncateUnit: TRUNCATE_UNITS.STRING,
          truncateAfter: 20
        },
        {
          text: 'Dashboard.widgets.storageelements.headers.organizationTypeLabel',
          value: 'organizationTypeLabel'
        },
        {
          text: 'Dashboard.widgets.storageelements.headers.canStoreProducts',
          value: 'canStoreProducts',
          presentWith: formatBool
        },
        {
          text: 'Dashboard.widgets.storageelements.headers.isMobile',
          value: 'isMobile',
          presentWith: formatBool
        }
      ],
      type: 'TABLE',
      moduleId: 'storageelements',
      withRouterActionLink: true
    },
    {
      id: 'storageelementsAmount',
      path: 'storageelements',
      type: 'VALUE',
      getData: response => response.data.totalHits,
      moduleId: 'storageelements'
    }
  ],
  STORAGE_ORGANIZATION_WIDGETS: [
    {
      id: 'storageorganizationtypes',
      path: 'storageorganizationtypes',
      getData: response => response.data.data?.map(item => item.data),
      headers: [
        {
          text: 'Common.label',
          value: 'label',
          truncateUnit: TRUNCATE_UNITS.STRING,
          truncateAfter: 20
        },
        {
          text: 'Dashboard.widgets.storageorganizationtypes.headers.parentLabelPathElements',
          value: 'parentLabelPathElements',
          presentWith: formatPathName
        },
        {
          text: 'Dashboard.widgets.storageorganizationtypes.headers.canStoreProducts',
          value: 'canStoreProducts',
          presentWith: formatBool
        },
        {
          text: 'Dashboard.widgets.storageorganizationtypes.headers.isMobile',
          value: 'isMobile',
          presentWith: formatBool
        }
      ],
      type: 'TABLE',
      moduleId: 'storageelements',
      withRouterActionLink: true
    },
    {
      id: 'storageorganizationtypesAmount',
      path: 'storageorganizationtypes',
      type: 'VALUE',
      getData: response => response.data.totalHits,
      moduleId: 'storageorganizationtypes'
    }
  ],
  STORAGE_STOCK_WIDGETS: [
    {
      id: 'storageelementstockAmount',
      path: 'storageelementstock',
      type: 'VALUE',
      getData: response => response.data.totalHits,
      moduleId: 'storageelementstock'
    },
    {
      id: 'stockmovements',
      getData: response => response.data.data?.map(item => item.data),
      path: 'stockmovements',
      headers: [
        {
          text: 'Common.type',
          value: 'transactionType',
        },
        {
          text: 'Dashboard.widgets.stockmovements.headers.source',
          value: 'source'
        },
        {
          text: 'Dashboard.widgets.stockmovements.headers.target',
          value: 'target'
        },
        {
          text: 'Common.amount',
          value: 'sourceAmount'
        },
        {
          text: 'Common.product',
          value: 'sourceProductLabel'
        },
        {
          text: 'Common.device',
          value: 'sourceDevice'
        },
        {
          text: 'Common.mobileUnit',
          value: 'sourceMobileUnit'
        },
        {
          text: 'Common.createdBy',
          value: 'createdBy'
        }
      ],
      defaultFilters: {sort: 'date:asc'},
      type: 'TABLE',
      moduleId: 'storageelementstock'
    },
    {
      id: 'stockmovementsTotal',
      path: 'stockmovements',
      type: 'VALUE',
      getData: response => response.data.totalHits,
      moduleId: 'storageelementstock'
    },
  ]
});

export default WAREHOUSE_WIDGETS;
